// Assign the site with the matching slug to selectedSite
async function fetchSite(siteSlug, setSelectedSite, setLoading) {
	const res = await fetch(
		`${process.env.REACT_APP_API_URL}/sites?slug=${siteSlug}`,
		{ credentials: "include" }
	);
	const sites = await res.json();
	if (sites.success) {
		let thisSite = sites.data.filter((site) => site.slug === siteSlug);
		thisSite = thisSite[0];
		setSelectedSite(thisSite);
		if (setLoading) {
			setLoading(false);
		}
	} else {
		console.log(sites.error);
	}
}

export default fetchSite;
